import React, { Component } from 'react';
import { GlobalContext } from '../../interfaces/GlobalContext/GlobalContext';
import HeaderShopCampaignProps from './HeaderShopCampaign.props';
import IHeaderShopCampaignState from './HeaderShopCampaign.state';
import ProductProperties from '../../interfaces/ProductProperties/ProductProperties';
import { EHeaderShopCampaignData } from '../../interfaces/HeaderShopCampaign/EHeaderShopCampaign';

export default class HeaderShopCampaign extends Component<HeaderShopCampaignProps, IHeaderShopCampaignState> {
    static contextType = GlobalContext;
    context!: React.ContextType<typeof GlobalContext>;
    private choiceList: React.RefObject<HTMLUListElement>;

    constructor(props: HeaderShopCampaignProps) {
        super(props);
        this.state = {
            fixed: this.props.fixed || false,
            pageDetails: this.props.pageDetails,
            products: []
        };

        this.choiceList = React.createRef<HTMLUListElement>();
    }

    componentDidMount(): void {
        this.modifyBackToStep1Button();
        this.getPageDetails();
    }

    modifyBackToStep1Button() {
        const step1button = document.getElementById('step1button') as HTMLAnchorElement;

        if (!step1button) {
            return;
        } else {
            step1button.href = '';

            step1button?.addEventListener('click', () => {
                if (this.props.navigateFunction) {
                    this.props.navigateFunction('/');
                }
            })
        }
    }

    // gets campaignid and pagetype from globalStates
    getPageDetails() {
        const campaignId = this.props.pageDetails.campaignId;
        const pageType = this.props.pageDetails.pageType;
        // console.log('campaignId from GlobalStates', campaignId);

        if (!campaignId || !pageType) {
            // TODO: Error Case - maybe global alert function?
            console.log('missing types - pageDetails: ', this.props.pageDetails)
            return;
        }

        this.setState({
            pageDetails: {
                pageType: pageType,
                campaignId: campaignId
            }
        }, () => {
            if (this.props.navigateFunction && this.props.updateProducts) {
                this.getProductsFromLs(campaignId, pageType)
            }
        })
    }

    // gets products from specific basket in LocalStorage upon campaignId and pageType
    getProductsFromLs(campaignId: string, pageType: string) {
        const cartData = this.context.localStorageProvider.getProductInformationForCampaingOrder(campaignId, pageType);

        if (!cartData) {
            // TODO: catch error
            if (this.props.navigateFunction) {
                this.props.navigateFunction('/');
            }
            return;
        }

        cartData.forEach(product => {
            this.createAndAddListItem(product);
        })

        if (this.props.updateProducts) {
            this.props.updateProducts(cartData)
        }
        // this.addEventlistenerToProductSelectionRemoveButton();
    }

    // Adds listItem to productSelection of Header
    createAndAddListItem(product: ProductProperties) {
        const currentItems = this.choiceList.current?.children || [];

        // Checks if item product is in list already
        if (currentItems.length > 0) {
            for (let i = 0; i < currentItems?.length; i++) {
                if (currentItems[i].id === product.magicNumber) {
                    return;
                }
            }
        }

        const createListElement: HTMLLIElement = document.createElement('li');
        createListElement.id = product.magicNumber;

        const innerHTML = `
            <div class="text-icon-link text-icon-link--checkmark">
                <span class="text-icon-link__icon--hidden text-icon-link--checkmark"></span>
                <span class="text-icon-link__text">${product.title}</span>
            </div>
            <button id="${product.magicNumber}-button" class="text-icon-link text-icon-link--trash text-icon-link--button product-selection-multitest-result__remove-item-button" type="button" title="entfernen">
                <span class="text-icon-link__icon text-icon-link--checkmark"></span>
                <span class="text-icon-link__text"></span>
            </button>
        `;

        createListElement.innerHTML = innerHTML;
        this.choiceList.current?.appendChild(createListElement);
        this.addEventlistenerToProductSelectionRemoveButton(product);
    }

    // adds onClick-function to 'remove'-button of productChoiceList
    addEventlistenerToProductSelectionRemoveButton(product: ProductProperties) {
        if (!this.choiceList.current) {
            // TODO: Error handling
            return;
        }

        const button = document.getElementById(`${product.magicNumber}-button`);

        button?.addEventListener('click', () => {
            if (!this.props.pageDetails || !this.props.pageDetails.campaignId || !this.props.pageDetails.pageType) {
                // TODO: catch error
                return;
            }
            button.parentElement?.remove();

            this.context.localStorageProvider.removeProductInformationFromCampaignOrderCartByMagicNumber(this.props.pageDetails.campaignId, this.props.pageDetails.pageType, product.magicNumber);

            if (this.choiceList.current && this.choiceList.current.childNodes.length < 1 && this.props.navigateFunction) {
                window.history.back();
            }
        })
    }

    getHeaderImage() {
        return this.props.pageDetails.headerImg || this.context.i18nProvider.get(this.props.pathForContent + ".imageSrc");
    }

    getHeaderImageSmall() {
        return this.props.pageDetails.headerImgSmall || this.getHeaderImage();
    }

    render(): React.ReactNode {
        return (
            <>
                <header className="topic-header topic-header--multitest">
                    <div className="topic-header__visual" style={{backgroundImage: `url(${this.getHeaderImage()}`}}>
                        <picture className="picture topic-header__picture">
                            {/* <source media="(min-width: 1600px)" srcSet={`${this.getHeaderImage()} 1x, assets/images/topic-header/home/juris-headimage-home-large.jpg 2x`} />
                            <source media="(min-width: 1190px)" srcSet={`${this.getHeaderImage()} 1x, assets/images/topic-header/home/juris-headimage-home-large.jpg 2x`} /> */}
                            <source media="(max-width: 576px)" srcSet={`${this.getHeaderImageSmall()} 1x`} />
                            <img src={`${this.getHeaderImage()}`} srcSet={`${this.getHeaderImage()} 1x`} alt={`${this.context.i18nProvider.get(this.props.pathForContent + ".imageAlt")}`} loading="lazy" />
                        </picture>
                    </div>
                    <div className="topic-header__container container topic-header__container--multitest">
                        {this.props.pathForContent === EHeaderShopCampaignData.CUSTOMERDATAPATH + '.' + this.props.pageDetails.pageType &&
                            <div className="row">
                                <div className="topic-header__content-col col-12">
                                    <div className="button-container button-container--topic-header">
                                        <a className="text-icon-link text-icon-link--back-light-gray-white step1button" href="#step1form" id="step1button">
                                            <span className="text-icon-link__icon"></span>
                                            <span className="text-icon-link__text">
                                                {this.context.i18nProvider.get(EHeaderShopCampaignData.CUSTOMERDATAPATH + '.' + EHeaderShopCampaignData.BACKBUTTON)}
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="row">
                            <div className="topic-header__content-col col-xs-12 col-sm-12 col-md-7">
                                <h2 className="topic-header__subtitle">{this.context.i18nProvider.get(this.props.pathForContent + "." + EHeaderShopCampaignData.HEADLINE)}</h2>
                                <span dangerouslySetInnerHTML={{ __html: this.context.i18nProvider.get(this.props.pathForContent + "." + EHeaderShopCampaignData.SUBTITLE) || ''}}></span>
                            </div>
                            {this.props.pathForContent === EHeaderShopCampaignData.CUSTOMERDATAPATH + '.' + this.props.pageDetails.pageType && this.props.pageDetails.singleProduct !== 'true' &&
                            <div className="topic-header__content-col col-xs-12 col-sm-12 col-md-5">
                                <div className="product-selection-multitest-result--topic-header">
                                    <p>{this.context.i18nProvider.get(this.props.pathForContent + "." + EHeaderShopCampaignData.SELECTIONLABEL)}</p>
                                    <ul ref={this.choiceList} className="product-selection-multitest-result__yourChoiceList product-selection-multitest-result__yourChoiceList--topic-header">
                                    </ul>
                                </div>

                            </div>}
                        </div>
                    </div>
                </header>
            </>
        );
    }
}
